import React, { forwardRef } from "react"
import { SettingMicrophone } from "./settingsMicrophone"
import { FaVideoSlash } from "react-icons/fa"
import { Icon } from "../common/icons"
import {
  SettingsBody,
  Progress,
  ProgressBar,
  VideoWrapper,
  Video,
  VideoContainer
} from "./settings.styled"
import { SettingsProps } from "./settings.interfaces"
import { brandingSelector } from "../../recoil/atoms/room"
import { useRecoilValue } from "recoil"
import { SettingCamera } from "./settingsCamera"
import { replaceOpacity, getOpacity, isRGBAcolor } from "../../util"
import useWindowSize from "../../hooks/useWindowSize"
import ConditionalSettingsCamera from "src/conditionals/SettingsCamera"

const SettingsSettings = forwardRef<HTMLDivElement, SettingsProps>(
  (
    {
      devicesLists,
      handleChangeMuteDevice,
      handleChangeDevice,
      currentAudio,
      currentVideo,
      currentMutedDevices,
      volume,
      isShowFullView,
      tracks,
      isHomePage,
      devicePermissionDenied
    },
    ref
  ) => {
    const roomStyles = useRecoilValue(brandingSelector)

    const { screenSize } = useWindowSize()
    const isSmallView = React.useMemo(
      () => 570 > screenSize.height || screenSize.width < 1024,
      [screenSize.height, screenSize.width]
    )

    const wrapperWidth = React.useMemo<string>(() => {
      if (570 > screenSize.height && !isHomePage) {
        return `${(277 * screenSize.height) / 570}px`
      }
      return "100%"
    }, [isHomePage, screenSize.height])

    const сolorBorder = React.useMemo<string>(() => {
      if (isRGBAcolor(roomStyles?.servicePanelElementBorder)) {
        return getOpacity(roomStyles?.servicePanelElementBorder) > 0.3
          ? replaceOpacity(
              roomStyles?.servicePanelElementBorder,
              getOpacity(roomStyles?.servicePanelElementBorder) - 0.3
            )
          : replaceOpacity(roomStyles?.servicePanelElementBorder, 0.1)
      }
      return `${roomStyles?.servicePanelElementBorder}b3` ?? "#28a745"
    }, [roomStyles?.servicePanelElementBorder])
    return (
      <SettingsBody roomStyles={roomStyles}>
        <SettingMicrophone
          currentMutedDevices={currentMutedDevices}
          handleChangeMuteDevice={handleChangeMuteDevice}
          isShowFullView={isShowFullView}
          roomStyles={roomStyles}
          handleChangeDevice={handleChangeDevice}
          currentAudio={currentAudio}
          devicesLists={devicesLists}
          audioTrack={tracks.audio}
          isHomePage={isHomePage}
          сolorBorder={сolorBorder}
          devicePermissionDenied={devicePermissionDenied}
        />
        <Progress
          сolorBorder={сolorBorder}
          roomStyles={roomStyles}
          isHomePage={isHomePage}
          isSmallWindowHeight={isSmallView && !isHomePage}
        >
          <ProgressBar
            style={{
              width: `${volume * 100}%`,
              backgroundColor: isHomePage
                ? "#e2e8f0"
                : roomStyles.servicePanelElementPrimaryText ?? "#28a745"
            }}
          />
        </Progress>
        <ConditionalSettingsCamera
          roomStyles={roomStyles}
          isShowFullView={isShowFullView}
          currentMutedDevices={currentMutedDevices}
          handleChangeDevice={handleChangeDevice}
          currentVideo={currentVideo}
          handleChangeMuteDevice={handleChangeMuteDevice}
          devicesLists={devicesLists}
          tracks={tracks}
          isHomePage={isHomePage}
          сolorBorder={сolorBorder}
          devicePermissionDenied={devicePermissionDenied}
          wrapperWidth={wrapperWidth}
          isSmallView={isSmallView && !isHomePage}
          ref={ref}
        />
      </SettingsBody>
    )
  }
)

export default SettingsSettings
